import React from 'react';
import { Box, Typography, Chip, LinearProgress } from '@mui/material';
import { useTranslation } from '../i18n/i18n';

const toPercent = (score, max) => (score / max) * 100;

function PsychometricResultsSummary({ results }) {
  const { t } = useTranslation();
  const totalPercent = results ? Math.round(toPercent(results.total_score, results.max_total_score)) : 0;

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
        {t('psychometric_test_results')}
      </Typography>
      {results ? (
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
            <Chip
              label={`${totalPercent}%`}
              color={totalPercent >= 50 ? 'success' : 'warning'}
              size="small"
              sx={{ fontWeight: 600 }}
            />
            <Typography variant="caption" color="text.secondary">
              {results.total_score} / {results.max_total_score}
            </Typography>
          </Box>
          {results.trait_scores && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              {Object.entries(results.trait_scores).map(([trait, scores]) => {
                const percent = toPercent(scores.score, scores.max_score);
                return (
                  <Box key={trait} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ minWidth: 80 }}>
                      {t(`trait_${trait}`)}
                    </Typography>
                    <LinearProgress
                      variant="determinate"
                      value={percent}
                      sx={{ flex: 1, height: 6, borderRadius: 3 }}
                      color={percent >= 50 ? 'success' : 'warning'}
                    />
                    <Typography variant="caption" color="text.secondary" sx={{ minWidth: 40, textAlign: 'right' }}>
                      {Math.round(percent)}%
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          )}
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
          {t('psychometric_test_results_notavailable')}
        </Typography>
      )}
    </Box>
  );
}

export default PsychometricResultsSummary;
